import React from 'react';

import PropTypes from 'prop-types';
import {formValueSelector} from 'dcx/form/utils/FormUtils'

import Grid from '@mui/material/Grid';

import TextField from 'dcx/form/Field/TextField';
import CTAButton from 'dc/components/buttons/CTAButton';

import {connect} from 'react-redux';

import DcxFormField from 'dcx/form/DcxFormField';
import DcxForm, {AUTOCOMPLETE, READONLY, VARIANT} from 'dcx/form/DcxForm';

import {
	hasEmailAddressValidationError,
	hasTokenValidationError,
	validateFormValues
} from 'dcx/form/utils/ValidationUtils';

import LoadingProgress from 'dc/components/modules/LoadingProgress';
import FinalFormStateToReduxPropagator from 'dcx/form/FinalFormStateToReduxPropagator';

const validateSigninFields = values => {
	const errors = validateFormValues(values, (key, value) => {
		let errorMessage = null;
		switch (key) {
			case 'mbox':
				if (!value) {
					errorMessage = 'Required';
				} else {
					errorMessage = hasEmailAddressValidationError(value);
				}
				break;
			default:
				break;
		}
		return errorMessage;
	})
debugger;
	return errors
}

const styleSheet = theme => ({
	footer: {
		paddingTop: 16,
	},
})

class NextSignInForm extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
			invalidForm: true
		}
	}

	canSubmitForm() {
		const {mbox} = this.props;
		//console.log('mbox', mbox);
		if (mbox) {
			this.setState({invalidForm: false})
			//	todo add validation check on fields then setState
		} else {
			this.setState({invalidForm: true})
		}
	}

	render() {
		const {
			classes={},
			onSendPin,
			onSubmitPin,
			signInMessage,
			isActive,
			mbox="",
			pin=""
		} = this.props;

		const {invalidForm} = this.state;

		let formObject = { mbox, pin }

        console.log(`validate ${invalidForm} ${isActive}`)

		return (
			<DcxForm
			    formKey={'signIn'}
				noValidate
				onSubmit={()=>{}}
				form={'signIn'}
				validate={validateSigninFields}
				initialValues={{}}
				commands={[
					{type: VARIANT, value: 'outlined'},
					{type: AUTOCOMPLETE, value: false},
					{type: READONLY, value: isActive}
				]}
				renderAction={({values}) => {
				 //console.log("****************", values)
                formObject = {...values}
                return (
                    <form>

                    {signInMessage && (
                        <Grid size={{xs:12}}>
                            {signInMessage}
                        </Grid>
                    )}
                    {isActive && (
                        <Grid size={{xs:12}}>
                            <LoadingProgress/>
                        </Grid>
                    )}
                    <Grid size={{xs:12}}>
                        <DcxFormField
                            component={TextField}
                            label='Mailbox'
                            name='mbox'
                            required
                        />
                    </Grid>

                    <Grid size={{xs:12}}>
                        <Grid container justify='space-between' alignItems='center' className={classes.footer}>
                            <Grid size={{xs:12}}>
                                <CTAButton
                                    buttonText={'SEND PIN'}
                                    disabled={/*invalidForm || */isActive}
                                    onClick={() => {
                                        onSendPin(formObject);
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={{xs:12}}>
                        <DcxFormField
                            component={TextField}
                            label='Pin'
                            name='pin'
                            required
                        />
                    </Grid>
                    <Grid size={{xs:12}}>
                        <Grid container justify='space-between' alignItems='center' className={classes.footer}>
                            <Grid size={{xs:12}}>
                                <CTAButton
                                    buttonText={'SUBMIT PIN'}
                                    disabled={/*invalidForm || */isActive}
                                    onClick={() => {
                                        onSubmitPin(formObject);
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    </form>
                 )}}
			/>
		)
	}
}

const mapStateToProps = (state) => {
	const mbox = "";
	const pin = "";
	return {mbox, pin,}
}

NextSignInForm.propTypes = {
	classes: PropTypes.object.isRequired,
}

export default connect(mapStateToProps)(NextSignInForm)
